import React from 'react'
import AdherenceRingLight from './AdherenceRingLight'
import RecCard from './RecCard'
import { PILLAR_ICONS } from './constants'
import styles from './ProtocolInfographic.module.css'

export default function PillarColumn({ pillar, data }) {
  if (!data) {
    return null
  }

  const sorted = [...(data.recommendations || [])].sort((a, b) => (b.impact_score || 0) - (a.impact_score || 0))
  const pillarKey = pillar && pillar.key ? pillar.key : 'default'
  const pillarIcon = PILLAR_ICONS[pillarKey] || '💪'

  return (
    <div className={styles.pillarCard}>
      <div
        className={styles.pillarHeader}
        style={{
          background: `linear-gradient(135deg, ${pillar.accent} 0%, color-mix(in oklab, ${pillar.accent} 70%, black) 100%)`
        }}
      >
        <div className={styles.headerRow}>
          <div className={styles.pillarInfo}>
            <div className={styles.iconBox}>
              <span role="img" aria-label={pillar.label} className={styles.pillarIcon}>{pillarIcon}</span>
            </div>
            <div className={styles.pillarText}>
              <div className={styles.pillarLabel}>Pillar</div>
              <h2 className={styles.pillarName}>{pillar.label}</h2>
            </div>
          </div>
          <AdherenceRingLight value={(data.key_metrics && data.key_metrics.current_adherence) || 0} />
        </div>
        <p className={styles.overallFocus}>{(data.summary && data.summary.overall_focus) || ''}</p>
      </div>

      {(data.key_metrics && data.key_metrics.top_gap) && (
        <div className={styles.gapBox} style={pillar.tint ? { '--pillar-tint': pillar.tint } : undefined}>
          <div className={styles.gapRow}>
            <div className={styles.gapHeader}>
              <span role="img" aria-label="target" className={styles.gapIcon} style={{ color: pillar.accent }}>🎯</span>
              <div className={styles.gapLabel} style={{ color: pillar.accent }}>Top Gap</div>
            </div>
            <p className={styles.gapText}>{data.key_metrics.top_gap}</p>
          </div>
        </div>
      )}

      {(data.quick_wins && data.quick_wins.length > 0) && (
        <div className={styles.quickWinsBox}>
        <div className={styles.quickWinsHeader}>
          <span role="img" aria-label="zap" className={styles.zapIcon} style={{ color: pillar.accent }}>⚡</span>
          <h3 className={styles.quickWinsTitle}>Quick Wins — Today</h3>
        </div>
          <ul className={styles.quickWinsList}>
            {data.quick_wins.map((w, i) => (
              <li key={i} className={styles.quickWinItem}>
              <span
                role="img"
                aria-label="check"
                className={styles.checkIcon}
                style={{ backgroundColor: pillar.accent }}
              >✓</span>
                <span className={styles.quickWinText}>{w}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {sorted.length > 0 && (
        <div className={styles.recsContainer}>
          <div className={styles.recsHeader}>
            <h3 className={styles.recsTitle}>Recommendations</h3>
            <span className={styles.recsCount}>
              {(data.summary && data.summary.top_priorities) || 0} priority · {(data.summary && data.summary.total_recommendations) || 0} total
            </span>
          </div>
          <div className={styles.recsList}>
            {sorted.map((rec, i) => (
              <RecCard key={i} rec={rec} accent={pillar.accent} />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
